var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertLevel1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132.29 132.29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alertLevel1_svg__a",
    x1: -43.03,
    x2: -41.828,
    y1: 99.692,
    y2: 27.796,
    gradientTransform: "translate(129.42 -32.826) scale(1.5358)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a22024",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a72527",
    stopOpacity: 0.973,
    offset: 0.026
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0262d",
    offset: 0.071
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#df232a",
    offset: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea4449",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ef6367",
    offset: 0.967
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2787c",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.498 121.2H33.924L1.637 65.277 33.924 9.354h64.574l32.287 55.923z",
    fill: "url(#alertLevel1_svg__a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.812 37.734c-2.08 0-4.16.797-5.754 2.391a8.12 8.12 0 000 11.51L54.7 65.28 41.058 78.922a8.12 8.12 0 000 11.51 8.12 8.12 0 0011.509 0L66.21 76.787 79.853 90.43a8.12 8.12 0 0011.51 0 8.12 8.12 0 000-11.51L77.72 65.28l13.643-13.644c3.188-3.188 3.188-8.321 0-11.51s-8.321-3.188-11.51 0L66.21 53.77 52.567 40.125a8.112 8.112 0 00-5.755-2.39z",
    fill: "#ecedee",
    style: {
      fontVariationSettings: "normal"
    }
  }));
}
export default SvgAlertLevel1;